import { Routes, Route } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import './App.css';
import './index.css';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import NOT from './components/404'
import Peshbinikrdn from './pages/Peshbinikrdn';
import Nmrakan from './pages/Nmrakan';
import { login } from './slice/userSlice';
import { useDispatch } from 'react-redux';
import Sportitems from './pages/Sportitems';
import Cart from './pages/Cart';
import Games from './pages/Games';
import Profile from './pages/AdminProfile';
import ChooseGift from './pages/ChooseGift';
import Settings from './pages/Settings';
import { changetheme } from './slice/themeSlice';
import Allpeshbini from './components/Allpeshbini';
import Allusersxal from './components/Allusersxal';
import Allusers from './components/Allusers';
import Info from './pages/Info';


// import Productinfo from './components/Productinfo';


function App() {


  useEffect(() => {
    localStorage.setItem('gift', JSON.stringify("https://static.nike.com/a/images/t_default/af4bd130-4042-4693-84cd-dd35b967240f/washington-commanders-terry-mclaurin-mens-game-football-jersey-j78GQ7.png"));

  }, [])


  const [path, setPath] = useState(<Login />)
  const dispatch = useDispatch();

  useEffect(() => {
    
    const username = JSON.parse(localStorage.getItem('username'));
    const theme = JSON.parse(localStorage.getItem('theme'));
    if (username) {
      dispatch(login(username));
      setPath(<Home />)
    }
    if(theme){
      dispatch(changetheme(theme));
    }



  }, [dispatch]);
  return (
    <>



      <Routes>

        <Route path='/home' element={<Home />} />
        <Route path='/' element={path} />
        <Route path='/login' element={<Login />} />
        <Route path='/nmra' element={<Nmrakan />} />
        <Route path='/register' element={<Register />} />
        <Route path='/peshbinikrdn' element={<Peshbinikrdn />} />
        <Route path='/sport' element={<Sportitems />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/games' element={<Games />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/profile/choosegift' element={<ChooseGift />} />
        <Route path='/settings' element={<Settings />} />
        <Route path='/profile/allpeshbini' element={<Allpeshbini />} />
        <Route path='/profile/allusersxal' element={<Allusersxal />} />
        <Route path='/profile/allusers' element={<Allusers />} />
        <Route path='/info' element={<Info />} />
        {/* <Route path='/productinfo/:id' element={<Productinfo/>} /> */}
        <Route path='*' element={<NOT />} />
      </Routes>


    </>
  );
}

export default App;
